import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';

import { Observable } from 'rxjs';
import { Carrier } from '../models/carrier';



@Injectable({
  providedIn: 'root'
})
export class carrierService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getCarriers(includeInactive: boolean = false): Observable<Carrier[]> {
    let queryParameters = new HttpParams();
    if (includeInactive != null) {
      queryParameters = queryParameters.set('includeInactive', String(includeInactive));
    }

    return this.httpClient.get<Carrier[]>(`${this.basePath}/api/carriers`);
  }

  public getCarrier(carrierId: number): Observable<Carrier> {
    return this.httpClient.get<Carrier>(`${this.basePath}/api/carriers/${carrierId}`);
  }

  public postCarrierDTO(carrierDTO: Carrier): Observable<Carrier> {
    return this.httpClient.post<Carrier>(`${this.basePath}/api/carriers`, carrierDTO);
  }

  public putCarrierDTO(carrierDTO: Carrier): Observable<Carrier> {
    return this.httpClient.put<Carrier>(`${this.basePath}/api/carriers/${carrierDTO.id}`, carrierDTO);
  }

  public deleteCarrierDTO(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/carriers/${id}`);
  }

}
